'use strict';

class UserWelcomeEmail {
  constructor($location, userService, originatorService, notificationService, I18N) {
    this.$location = $location;
    this.userService = userService;
    this.originatorService = originatorService;
    this.notificationService = notificationService;
    this.I18N = I18N;
  }

  $onInit() {
    this.id = this.$location.search().notification;
    this.oldEmail = null;

    this.email = null;
    this.originator = {};
    this.settings = {};
    this.alert = {};

    // get user email
    this.userService.get()
      .then((resp) => {
        this.email = resp.data.userName;
        this.oldEmail = resp.data.userName;
      })
      .catch((err) => {
        this.alert = {
          type: 'error',
          message: err.data.endUserMessage
        };
      });

    this.originatorService.get()
      .then((resp) => {
        this.originator = resp.data;
      })
      .catch((err) => {
        this.alert = {
          type: 'error',
          message: err.data.endUserMessage
        };
      });

    this.originatorService.settings()
      .then((resp) => {
        this.settings = resp.data;
      })
      .catch((err) => {
        this.alert = {
          type: 'error',
          message: err.data.endUserMessage
        };
      });
  }

  displayError(err) {
    this.alert = {
      type: 'error',
      message: err.data.errors[0].endUserMessage
    };
  }

  send() {
    if (this.oldEmail !== this.email) {
      // change invoice printed address
      this.settings.sendRegningContactEmail = this.email;
      this.originatorService.updateSettings(this.settings)
        .then(() => {
          // change contact address
          this.originator.contact.email = this.email;
          this.originatorService.update(this.originator)
            .then(() => {
              // mark notification
              this.notificationService.markAsRead(this.id)
                .then(() => {
                  // update user email
                  this.userService.updateEmail(this.email)
                    .then(() => {
                      // send the email again
                      this.userService.resendWelcomeEmail(this.originator.id)
                        .then(() => {
                          this.$location.path('/beslutning-kreves');
                        })
                        .catch((err) => this.displayError(err));
                    })
                    .catch((err) => this.displayError(err));
                })
                .catch((err) => this.displayError(err));
            })
            .catch((err) => this.displayError(err));
        })
        .catch((err) => this.displayError(err));
    } else {
      this.alert = {
        type: 'error',
        message: this.I18N.user.error.sameEmail
      };
    }
  }
}

UserWelcomeEmail.$inject = ['$location', 'userService', 'originatorService', 'notificationService', 'I18N'];

const userWelcomeEmail = {
  controller: UserWelcomeEmail,
  template: `
    <alert data="$ctrl.alert" />

    <h2>Endre e-postadresse</h2>

    <fieldset>
      <label for="email">E-postadresse</label>
      <input type="email" id="email" name="email" autocomplete="email" ng-model="$ctrl.email" maxlength="64" placeholder="ola@nordmann.no" required>
      <button class="button" ng-click="$ctrl.send()">Send</button>
    </fieldset>
  `
};

angular
  .module('SendRegning')
  .component('userWelcomeEmail', userWelcomeEmail)
  .config(($routeProvider) => {
    $routeProvider
      .when('/bruker/velkomstbrev', {
        title: 'Velkomstbrev',
        template: '<user-welcome-email />',
        secure: true
      });
  });
